import { SearchInput, useListContext } from 'react-admin';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

export const SearchBar = ({ className, fields, ...params }) => {
    const { setFilters, filterValues, displayedFilters } = useListContext();

    useEffect(() => {
        if (!fields || !filterValues?.search?.value) {
            return;
        }

        const currentFields = filterValues.search.fields || {};
        const fieldsMatch =
            Object.keys(fields).length === Object.keys(currentFields).length && Object.keys(fields).every(key => currentFields[key] === fields[key]);
        if (fieldsMatch) {
            return;
        }

        setFilters({
            ...filterValues,
            search: {
                ...filterValues.search,
                fields,
            },
        });
    }, [fields, filterValues, setFilters]);

    useEffect(() => {
        const searchBarElement = document.querySelector('#search-bar');
        const parentElement = searchBarElement?.closest('.filter-field');
        const hideFilterElement = parentElement?.querySelector('.hide-filter');

        if (parentElement) {
            parentElement.classList.add('search-bar--hidden');
        }

        if (hideFilterElement) {
            const handleHideFilter = () => {
                if (Object.keys(filterValues).length !== 0) {
                    const newFilterValues = { ...filterValues };
                    delete newFilterValues.search;
                    const newDisplayedFilters = { ...displayedFilters };
                    delete newDisplayedFilters.value;
                    setFilters(newFilterValues, newDisplayedFilters);
                }
            };

            hideFilterElement.addEventListener('click', handleHideFilter);

            // Cleanup function
            return () => {
                hideFilterElement.removeEventListener('click', handleHideFilter);
                if (parentElement) {
                    parentElement.classList.remove('search-bar--hidden');
                }
            };
        }
    }, [filterValues, displayedFilters, setFilters]);

    return (
        <>
            <SearchInput source={`search.${params.source}`} sx={{ marginRight: 4 }} id='search-bar' className={className} />
        </>
    );
};

SearchBar.propTypes = {
    className: PropTypes.string,
    source: PropTypes.string.isRequired,
    label: PropTypes.string,
    alwaysOn: PropTypes.bool,
    fields: PropTypes.object,
};
